import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge23 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='太平洋クラブとは？' fontWeight={700} />
                <p>
                    太平洋クラブは、日本全国に18のゴルフ場を展開する大手ゴルフ場運営グループです。各地域の特性を活かした多様なコース設計と、充実したファシリティで幅広いゴルファーに愛されています。
                    <br />
                    <br />
                    太平洋クラブが運営するゴルフ場は全国に18ヶ所あります。（※2024年9月現在）
                    <br />
                    <br />・<a href='/courses/600'>太平洋クラブ札幌コース（北海道）</a>
                    <br />・<a href='/courses/607'>太平洋クラブ白河コース（福島県）</a>
                    <br />・<a href='/courses/265'>太平洋クラブ軽井沢リゾート（群馬県）</a>
                    <br />・<a href='/courses/266'>太平洋クラブ高崎コース（群馬県）</a>
                    <br />・<a href='/courses/235'>太平洋クラブ大洗シャーウッドコース（茨城県）</a>
                    <br />・<a href='/courses/236'>太平洋クラブ美野里コース（茨城県）</a>
                    <br />・<a href='/courses/186'>太平洋クラブ佐野ヒルクレストコース（栃木県）</a>
                    <br />・<a href='/courses/187'>太平洋クラブ益子PGAコース（栃木県）</a>
                    <br />・<a href='/courses/140'>太平洋クラブ江南コース（埼玉県）</a>
                    <br />・<a href='/courses/325'>太平洋クラブ御殿場コース（静岡県）</a>
                    <br />・<a href='/courses/324'>太平洋クラブ御殿場WEST（静岡県）</a>
                    <br />・<a href='/courses/30'>太平洋クラブ相模コース（神奈川県）</a>
                    <br />・<a href='/courses/77'>太平洋クラブ市原コース（千葉県）</a>
                    <br />・<a href='/courses/78'>太平洋クラブ成田コース（千葉県）</a>
                    <br />・<a href='/courses/79'>太平洋クラブ八千代コース（千葉県）</a>
                    <br />・<a href='/courses/1167'>太平洋クラブ六甲コース（兵庫県）</a>
                    <br />・<a href='/courses/1168'>太平洋クラブ宝塚コース（兵庫県）</a>
                    <br />・<a href='/courses/1169'>太平洋クラブ有馬コース（兵庫県）</a>
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='太平洋クラブの会員権について' fontWeight={700} />
                <p>
                    太平洋クラブの会員権は3種類あり、それぞれで利用可能なコースが異なります。
                    <br />
                    <br />
                    また、海外の提携クラブもあり、レシプロカル契約とアフィリエイト契約（※）のコースが存在します。
                    <br />
                    <br />
                    利用可能なコースは以下の通りです。
                    <br />
                    <br />
                    ※レシプロカル契約とは、双方の会員が相手先のコースを会員並みまたはそれ以上の安価なプレーフィで利用できる契約のことです。
                    アフィリエイト契約とは、優待価格で利用できる契約のことです。
                    <br />
                    <br />
                    1.<a href='/courses/597'>太平洋クラブ（共通会員権）</a>
                    <br />
                    ・国内18コース：
                    <br />
                    札幌コース、白河コース、軽井沢コース、高崎コース、大洗シャーウッドコース、美野里コース、佐野ヒルクレストコース、益子PGAコース、江南コース、御殿場コース、御殿場WEST、相模コース、市原コース、成田コース、八千代コース、六甲コース、宝塚コース、有馬コース
                    <br />
                    <br />
                    ・海外26クラブ：レシプロカル契約15コース＋アフィリエイト契約11コース
                    <br />
                    ※コース一覧は以下に記載
                    <br />
                    <br />
                    2.<a href='/courses/598'>太平洋アソシエイツ</a>
                    <br />
                    ・国内10コース：
                    <br />
                    札幌コース、白河コース、高崎コース、大洗シャーウッドコース、美野里コース、佐野ヒルクレストコース、益子PGAコース、江南コース、市原コース、有馬コース
                    <br />
                    <br />
                    ・海外11クラブ：アフィリエイト契約11コース
                    <br />
                    ※コース一覧は以下に記載
                    <br />
                    <br />
                    3.<a href='/courses/599'>太平洋クラブ関西エリア</a>
                    <br />
                    ・関西3コース：
                    <br />
                    六甲コース、宝塚コース、有馬コース
                    <br />
                    <br />
                    ・海外11クラブ：アフィリエイト契約11コース
                    <br />
                    ※コース一覧は以下に記載
                    <br />
                    <br />
                    ※レシプロカル契約15コース一覧
                    <br />
                    ザクリアウォーターベイ
                    ゴルフ＆カントリークラブ、ザナショナルゴルフクラブ、ロイヤルコロンボゴルフクラブ、ルベトゥーレ、TPCクアラルンプール、ザ・シンガポール・アイランド・カントリークラブ、アマタスプリング・カントリークラブ、コモンウェルスゴルフクラブ、エミレーツゴルフクラブ、ドバイ・クリーク、ヤスリンクス、ウェイハイポイントホテル＆ゴルフリゾート、ルゴルフナショナル、旗忠ゴルフクラブ、センチュリオンクラブ
                    <br />
                    <br />
                    ※アフィリエイト契約11コース一覧
                    <br />
                    ワイレアゴルフクラブ、プリンスビルマカイゴルフクラブ、コオリナゴルフクラブ、タートルベイリゾート、カポレイゴルフクラブ、エバビーチゴルフクラブ、ロイヤルハワイアンゴルフクラブ、ワイケレカントリークラブ、ゴルフメドックリゾート、サンテミリオンゴルフクラブ、タイ・カントリークラブ
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='太平洋クラブの共通会員権の魅力とは？' fontWeight={700} />
                <p>太平洋クラブの共通会員権の様々な魅力をご紹介します。</p>
                <Heading3 title='国内18コース、海外26クラブが自由に楽しめる共通会員権' />
                <p>
                    国内にある太平洋クラブ18コース全てと、海外にあるレシプロカル契約15コース、およびアフィリエイト契約11コースの26コースでプレーすることが可能です。
                    <br />
                    <br />
                    ※太平洋アソシエイツ・太平洋クラブ関西エリアの会員権で利用できるコースは異なりますのでお気を付けください。
                </p>
                <Heading3 title='年間200を超えるクラブ競技会' />
                <p>
                    太平洋クラブ・太平洋アソシエイツ会員は、クラブ認定のハンディキャップを取得することにより、月例杯やクラブ選手権など年間200を超える各種会員競技会に出場することができます。
                    <br />
                    競技会の中には、新ペリア方式でご家族ご友人と一緒に楽しめる競技や、年代別のコンペ競技など様々な形式のものがあり、ご自身のゴルフライフに合わせて参加することができます。
                </p>
                <Heading3 title='プロトーナメントの本戦やプロアマ大会への出場' />
                <p>
                    選手権試合など、プロトーナメントのプロアマ大会や本戦に出場できる権利を得られる特典付き競技会も有ります。
                    <br />
                    プロアマ大会には予選会があり、予選を通過し一般社団法人太平洋クラブ理事会の承認を得た場合にプロアマ大会の出場権を得ることが可能となります。
                    <br />
                    太平洋クラブ会員（関西エリア会員を含む）・太平洋アソシエイツ会員・太平洋宝塚クラブ会員で満16歳以上の方であれば予選会へ出場することが可能です。
                </p>
                <Heading3 title='太平洋クラブ銀座の利用' />
                <p>
                    太平洋クラブ銀座は、2020年にオープンした完全会員制の社交クラブで、
                    <br />
                    ランチやディナーとしてお食事やお酒を楽しむことはもちろん、カフェとして利用いただくなど様々な楽しみ方ができる特別な空間です。
                    <br />
                    <br />
                    また、インナークラブやイベントなども企画しておりますので、交流を深める場所としてもご利用されています。
                    <br />
                    <br />
                    太平洋クラブ・太平洋アソシエイツ会員は、入会金33万円および年会費3.3万円が免除され、太平洋クラブ銀座をいつでもご利用することが可能となります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='太平洋クラブのおすすめのゴルフ場は？' fontWeight={700} />
                <p>
                    太平洋クラブの全国のゴルフ場一覧は<a href='/courses?series_id=10'>こちら</a>よりご確認ください。
                    <br />
                    <br />
                    その中でも人気のあるゴルフ場の一部をご紹介します。
                </p>
                <Heading3 title='太平洋クラブのコースを一部ご紹介' />
                <p>
                    ・<a href='/courses/325'>太平洋クラブ御殿場コース</a>
                    <br />
                    <br />
                    太平洋クラブ御殿場コースは、世界的名設計家リース・ジョーンズの設計と松山英樹プロの監修による、日本を代表する国際水準のトーナメントコースです。
                    <br />
                    このコースは、1977年の開場以来、数々の名プレーヤーが参加する「三井住友VISA太平洋マスターズ」の舞台となり続けており、その歴史と伝統がゴルフファンを魅了しています。
                    <br />
                    そして2018年に全面改修が行われ、バンカーや池の形状、グリーン周辺の造形などが国際基準に合わせて大幅に見直されました。
                    <br />
                    また、富士山の美しい景観を楽しみながらラウンドできるのもこのコースの魅力です。
                    <br />
                    <br />・<a href='/courses/140'>太平洋クラブ江南コース</a>
                    <br />
                    <br />
                    太平洋クラブ江南コースは、高低差13メートルの土地に名匠加藤俊輔氏が設計した、フラットで戦略的なチャンピオンシップコースとなっています。
                    <br />
                    精密に配置されたバンカーや池により、プレーヤーの技術と戦略が求められます。
                    <br />
                    また、トーナメントクオリティのコンディションを常に維持されており、四季を通じて豊かな自然の美しさと、戦略性の高いコース設計が人気です。
                    <br />
                    <br />・<a href='/courses/1167'>太平洋クラブ六甲コース</a>
                    <br />
                    <br />
                    太平洋クラブ六甲コースは、ジャンボ尾崎プロも絶賛する戦略性の高いコースです。
                    <br />
                    特に、三つの池が配置された435ヤードのパー4である18番ホールが目玉。
                    <br />
                    広々としたフェアウェイが見渡せるものの、池やバンカーの配置により、正確なショットが求められるため、プロでも気を抜けない難度の高いホールとして知られています。
                    <br />
                    <br />
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='太平洋クラブの会員権をご購入された会員様の声' fontWeight={700} />
                <p>
                    <br />
                    住地ゴルフにて太平洋クラブの会員権をご購入された会員様にインタビューさせていただきました。
                    <br />
                    ぜひ会員権のご購入にお役立てください。
                    <br />
                    <br />
                    太平洋クラブ会員様の声は<a href='/member_voices/12'>こちら</a>
                    <br />
                    <br />
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    上述のように、太平洋クラブでは他にはない特有の特典が多数あります。
                    <br />
                    <br />
                    また、日本全国にゴルフ場があるため、将来的に転勤がある方や複数会員権を所有したい方からも人気を集めています。
                    <br />
                    <br />
                    具体的なコースの特徴や売買状況については、お気軽に弊社にお問合せください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge23;
